/* pdp-gallery-arrows.js
   Desktop prev/next arrows for the main PDP hero image.
   Added 2026-08-24 (user request): global gallery navigation, hooked into each
   template's EXISTING thumbnail click-handling — this script never swaps images
   itself, it only finds the currently active thumbnail for a gallery and simulates
   a click on the next/previous one, so every existing behavior (variant sync,
   crossfade, lightbox, thumbnail highlight) keeps working unchanged.

   Scope: only the "click-simulated" gallery systems opt in, via a
   .pdp-gallery-arrows wrapper carrying data-pdp-scope / data-pdp-thumb-sel:
     - beck-777 rail hero (BECK, vests, cockpit flagship, gloves, generic hero, Big Gib)
     - generic product-images.liquid thumbnail swap
     - BECK Premium PDP
   The Flickity-based galleries (legendary-product-gloves.liquid,
   main-product-cockpit-usa.liquid) do NOT use this script — they already have
   native .flickity-prev / .flickity-next support in assets/product-thumbnails.js,
   including wraparound and thumbnail sync, so the arrows there call into that
   existing system directly instead of duplicating it here. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function resolveScope(wrap) {
    var scopeSel = wrap.getAttribute('data-pdp-scope');
    if (!scopeSel) return document;
    return (wrap.closest(scopeSel)) || document.querySelector(scopeSel) || null;
  }

  function initGroup(wrap) {
    if (wrap.dataset.pdpArrowsInit === 'true') return;

    var thumbSel = wrap.getAttribute('data-pdp-thumb-sel');
    if (!thumbSel) return;

    var scope = resolveScope(wrap);
    if (!scope) {
      wrap.hidden = true;
      return;
    }

    var thumbs = scope.querySelectorAll(thumbSel);
    if (thumbs.length <= 1) {
      /* Only one product image (or none) — no arrows needed. */
      wrap.hidden = true;
      return;
    }

    wrap.dataset.pdpArrowsInit = 'true';

    var prevBtn = wrap.querySelector('[data-pdp-dir="prev"]');
    var nextBtn = wrap.querySelector('[data-pdp-dir="next"]');

    function go(delta) {
      var live = scope.querySelectorAll(thumbSel);
      if (live.length <= 1) return;
      var list = Array.prototype.slice.call(live);
      var idx = list.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (idx === -1) idx = 0;
      var targetIndex = (idx + delta + list.length) % list.length;
      var target = list[targetIndex];
      if (target && typeof target.click === 'function') target.click();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        go(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        go(1);
      });
    }
  }

  function initAll() {
    var groups = document.querySelectorAll('.pdp-gallery-arrows[data-pdp-thumb-sel]');
    groups.forEach(initGroup);
  }

  ready(initAll);
  /* Re-scan when the theme editor re-renders a section (design mode), so arrows
     keep working while a merchant is editing settings live. */
  document.addEventListener('shopify:section:load', initAll);
})();
